// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { mainNavigationStyles } from "@west/Overrides/Widgets/Header/MainNavigation";
import { color, ellipsis, layoutContainer } from "@west/XDL/Utilities";
import { css } from "styled-components";

mainNavigationStyles.menuHeight = 43;

mainNavigationStyles.container = {
    css: css`
        display: flex;
        align-items: center;
        overflow: hidden;
        gap: 96px;

        &[data-shrink="true"] {
            justify-content: space-between;
            gap: 5px;
        }

        ${layoutContainer}
    `,
};

mainNavigationStyles.itemWrapper = {};

mainNavigationStyles.menuItem = {
    css: css`
        display: flex;
        align-items: center;
        height: 43px;
        padding: 8px 12px;

        &:hover {
            ${TypographyStyle} {
                color: ${color("common.ui10")};
            }
        }
        &:focus {
            outline: none;
        }
    `,
};

mainNavigationStyles.menuItemTypography = {
    size: 16,
    weight: "bold",
    color: "common.black",
    transform: "uppercase",
    css: css`
        line-height: 20px;
        ${ellipsis(2)}
    `,
};
